export default __webpack_public_path__ + "static/media/edit-icon.20b3c57c.svg";